import { Pipe, type PipeTransform } from '@angular/core';
import { PhoneTypeEnum } from '@pecan/api/enums';

@Pipe({
    name: 'phoneTypeName',
})
export class PhoneTypeNamePipe implements PipeTransform {
    public transform(name: PhoneTypeEnum): string {
        switch (name) {
            case PhoneTypeEnum.Office:
                return 'office_phone_type';
            case PhoneTypeEnum.Mobile:
                return 'mobile_phone_type';
            case PhoneTypeEnum.Fax:
                return 'fax_phone_type';
            default:
                return '';
        }
    }
}
